import Child from '@/models/enrollment/child';
import CustodyArragement from '@/models/enrollment/custodyArragement';
import EmergencyContact from '@/models/enrollment/emergencyContact';
import SchoolArrangement from '@/models/enrollment/schoolArrangement';

export default {
  getLanguages: (state: any) => {
    return state.languages;
  },
  getSchoolArrangement: (state: any) => (childId: string): SchoolArrangement => {
    const foundChild = state.children.find((child: Child) => child.id == childId);

    return foundChild.schoolArrangement as SchoolArrangement;
  },
  getCustodyArrangement: (state: any) => (childId: string): CustodyArragement => {
    const foundChild = state.children.find((child: Child) => child.id == childId);

    return foundChild.custodyArrangement as CustodyArragement;
  },
  getEmergencyContacts: (state: any) => (childId: string): Array<EmergencyContact> | null => {
    const foundChild = state.children.find((child: Child) => child.id == childId);

    return foundChild.emergencyContacts;
  },
  getChildInfo: (state: any) => (childId: string) => {
    const foundChild = state.children.find((child: Child) => child.id == childId);
    
    let childInfo: any = {
      firstName: "",
      lastName: "",
      prefferedName: "",
      childAddress: null,
      dateOfBirth: "",
      age: null,
      childLanguages: null,
      enrollmentStepsCompleted: 0,
      additionalInfo: "",
      additionalEmergencyInfo: "",
      currentViewedStep: 0
    };

    if (foundChild) {
      childInfo = {
        firstName: foundChild.firstName,
        lastName: foundChild.lastName,
        prefferedName: foundChild.prefferedName,
        childAddress: foundChild.childAddress,
        dateOfBirth: foundChild.dateOfBirth,
        age: foundChild.age,
        childLanguages: foundChild.childLanguages,
        enrollmentStepsCompleted: foundChild.enrollmentStepsCompleted,
        additionalInfo: foundChild.additionalInfo,
        additionalEmergencyInfo: foundChild.additionalEmergencyInfo,
        currentViewedStep: foundChild.currentViewedStep
      };
    }
    return childInfo;
  },
  getChildren: (state: any) => {
    return state.children;
  },
  getAvailableChildren: (state: any) => (id: string) => {
    const availableChildrens = state.children.filter((child: Child) => child.enrollmentStepsCompleted == 15);

    return availableChildrens;
    // return state.children.filter((child: Child) => child.id !== id && child.enrollmentStepsCompleted == 15);
  },
  getChild: (state: any) => (id: string) => {
    return state.children.find((child: Child) => child.id == id);
  },
  getPickupPersons: (state: any) => (childId: string) => {
    const foundChild = state.children.find((child: Child) => child.id == childId);

    return foundChild.pickupPersons;
  },
  getVaccines: (state: any) => {
    return state.vaccines;
  },
  getChildrenVaccinationDates: (state: any) => (childId: string) => {    
    const foundChild = state.children.find((child: Child) => child.id == childId);

    return foundChild.childrenVaccinationDates;
  },
  getInitialHealthInfo: (state: any) => {
    return state.initialHealthInfo;
  },
  getHealthInfo: (state: any) => (childId: string) => {
    const foundChild = state.children.find((child: Child) => child.id == childId);

    const healthInfo = foundChild.healthInfo ? foundChild.healthInfo : null;

    return healthInfo;
  },
  getInitialAllergens: (state: any) => {
    return state.allergens;
  },
  getChildAllergyInfo: (state: any) => (childId: string) => {
    const foundChild = state.children.find((child: Child) => child.id == childId);

    return { allergens: foundChild.allergens, childAllergyInfo: foundChild.childAllergyInfo };
  },
  getInitialSkinProducts: (state: any) => {
    return state.skinProducts;
  },
  getChildSkinProducts: (state: any) => (childId: string) => {
    const foundChild = state.children.find((child: Child) => child.id == childId);

    return foundChild.skinProducts;
  },
  getChildFeedingArrangement: (state: any) => (childId: string) => {
    const foundChild = state.children.find((child: Child) => child.id == childId);
    
    return foundChild.feedingArrangement;
  },
  getChildPhysicalRequirements: (state: any) => (childId: string) => {
    const foundChild = state.children.find((child: Child) => child.id == childId);

    return foundChild.physicalRequirements;
  },
  getChildSleepArrangement: (state: any) => (childId: string) => {
    const foundChild = state.children.find((child: Child) => child.id == childId);
    
    return foundChild.sleepArrangement;
  }
}